import { defineStyleConfig } from "@chakra-ui/react";
import { fonts } from "../fonts";
import { colours, qoriaColours } from "../colours";

export const buttonTheme = defineStyleConfig({
	defaultProps: {
		variant: "solid",
	},
	baseStyle: {
		color: colours.text.title,
		bg: colours.neutrals[50],
		p: "20px",
		borderRadius: "md",
		_focus: {
			boxShadow: "outline",
		},
		fontFamily: fonts.buttons,
		fontWeight: 500,
	},
	variants: {
		solid: {
			bg: colours.brand[400],
			color: colours.text.white,
			_hover: {
				bg: colours.brand[500],
				_disabled: {
					bg: colours.brand[400],
				},
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.brand[500],
			},
		},
		subtle: {
			bg: colours.brand[200],
			color: colours.text.link.default,
			_hover: {
				bg: colours.brand[300],
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.brand[400],
			},
		},
		ghost: {
			bg: "transparent",
			color: colours.text.link.default,
			_hover: {
				bg: colours.brand[200],
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.brand[200],
			},
		},
		outline: {
			bg: "transparent",
			color: colours.text.link.default,
			borderColor: colours.brand[400],
			borderWidth: "1px",
			borderStyle: "solid",
			_hover: {
				bg: colours.neutrals[100],
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.neutrals[0],
				borderColor: colours.brand[400],
			},
			_disabled: {
				borderColor: "transparent",
			},
		},
		danger: {
			bg: colours.accent.red[400],
			color: colours.text.white,
			_hover: {
				bg: colours.accent.red[600],
				_disabled: {
					bg: colours.accent.red[400],
				},
			},
			_active: {
				// The style applied when the button is focused on or actively being clicked
				bg: colours.accent.red[600],
			},
		},
		dangerSubtle: {
			bg: colours.error.background,
			color: colours.error.plainText,
			_hover: {
				bg: colours.accent.red[200],
				color: colours.error.plainText,
			},
			_active: {
				bg: colours.accent.red[200],
				color: colours.error.plainText,
			},
		},
		dangerOutline: {
			bg: qoriaColours.brand.neutral[10],
			color: qoriaColours.brand.danger[500],
			borderColor: qoriaColours.brand.danger[100],
			borderWidth: "1px",
			borderStyle: "solid",
			_hover: {
				bg: qoriaColours.brand.danger[10],
				borderColor: qoriaColours.brand.danger[200],
				_disabled: {
					bg: qoriaColours.brand.neutral[10],
					borderColor: qoriaColours.brand.danger[100],
				},
			},
			_active: {
				bg: qoriaColours.brand.danger[10],
				borderColor: qoriaColours.brand.danger[200],
			},
		},
		neutralOutline: {
			bg: qoriaColours.brand.neutral[10],
			color: qoriaColours.brand.neutral[800],
			borderColor: qoriaColours.brand.neutral[200],
			borderWidth: "1px",
			borderStyle: "solid",
			borderRadius: "lg",
			_hover: {
				bg: qoriaColours.brand.neutral[50],
				_disabled: {
					bg: qoriaColours.brand.neutral[10],
				},
			},
			_active: {
				bg: qoriaColours.brand.neutral[50],
			},
		},
	},
	sizes: {
		small: {
			p: "14px",
			height: "34px",
		},
	},
});
